var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusConnectedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 866 492.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M779.3,158.9H661.6C626.6,66,537.5,0,433,0S239.4,66,204.4,158.9H86.7C38.8,158.9,0,198,0,246.2v0 c0,48.2,38.8,87.3,86.7,87.3h117.7c35,92.9,124.1,158.9,228.6,158.9s193.6-66,228.6-158.9h117.7c47.9,0,86.7-39.1,86.7-87.3v0 C866,198,827.2,158.9,779.3,158.9z M574.4,185.8c-58.9,59.5-101.8,108-162.1,168.9c-12.3,12.5-32.1,13.3-45.4,1.9l-72.7-61.9 c-0.5-0.4-1-0.9-1.5-1.3c-13.8-12.5-14.9-33.8-2.5-47.7c12.4-13.9,33.6-15,47.4-2.5l48.7,41.5c47.9-49.5,88.3-93.7,140.6-146.6 c6.1-6.3,14.3-9.9,23.1-10.2c9.3-0.3,18.4,3.4,24.9,10.1C587.8,151.3,587.6,172.7,574.4,185.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusConnectedIcon);
export default __webpack_public_path__ + "static/media/status-connected-icon.20119b84fcd9d9b5c308f341695aa22c.svg";
export { ForwardRef as ReactComponent };